import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineUpRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.6 6c0-.665-.536-1.2-1.2-1.2-.666 0-1.2.535-1.2 1.2v17.2c0 2.21 1.79 4 4 4h20.4c.664 0 1.2-.535 1.2-1.2s-.536-1.2-1.2-1.2H7.2c-.886 0-1.6-.715-1.6-1.6zm13.6 4.8c0 .665.534 1.2 1.2 1.2h2.704L18.4 16.705l-3.95-3.95c-.47-.47-1.23-.47-1.695 0l-4.4 4.4a1.2 1.2 0 0 0 1.695 1.695l3.55-3.55 3.95 3.95c.47.47 1.23.47 1.695 0l5.55-5.55v2.705c0 .665.535 1.2 1.2 1.2s1.2-.535 1.2-1.2v-5.6c0-.665-.535-1.2-1.2-1.2h-5.6c-.665 0-1.2.535-1.2 1.2z" })
});
export default SvgChartLineUpRegularIcon;
